export default __webpack_public_path__ + "static/media/overlay-propos.dcd4544c.png";